var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"msg-view"},[_c('van-skeleton',{attrs:{"title":"","avatar":"","row":3,"loading":_vm.loading}},[_c('div',{staticStyle:{"font-size":".25rem"}},[_vm._v(_vm._s(_vm.msg))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }